import React from 'react'
import { Outlet } from 'react-router-dom'

function MainEmail() {
  return (
    <div>
      <Outlet/>
    </div>
  )
}

export default MainEmail
